/**
 * token 操作封装
 */
import { TOKEN_STORE_NAME } from "@/config/setting";

/**
 * @description: 获取 token
 * @return {string | null} token
 */
export function getToken(): string | null {
  const token = localStorage.getItem(TOKEN_STORE_NAME);
  if (!token) {
    return sessionStorage.getItem(TOKEN_STORE_NAME);
  }
  return token;
}

/**
 * @description: 存储 token
 * @param {boolean} remember 是否永久储存
 * @param {string} token token
 * @return {*}
 */
export function setToken(remember?: boolean, token?: string): boolean | void {
  removeToken();
  if (!token) return false;
  remember
    ? localStorage.setItem(TOKEN_STORE_NAME, token)
    : sessionStorage.setItem(TOKEN_STORE_NAME, token);
}

/**
 * @description: 移除 token
 * @return {*}
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_STORE_NAME);
  sessionStorage.removeItem(TOKEN_STORE_NAME);
}
